export type ClassValue = string | false | null | undefined;

/**
 * Joins class names into a single space-separated string, dropping any falsy
 * values. A tiny `clsx`/`classnames`-style helper for conditional classes.
 *
 * @param classes - Class names, or falsy values to skip (`false`/`null`/`undefined`/`""`).
 * @returns The truthy class names joined by a single space.
 *
 * @example
 * cx("card", isActive && "card--active", className)
 */
export const cx = (...classes: ClassValue[]): string => classes.filter(Boolean).join(" ");
